import React from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useWizard, DetailEntityType } from "./WizardContext";

interface WizardEntityLinkProps {
  entityType: DetailEntityType;
  entityId: string;
  label?: string | undefined;
  data?: Record<string, any> | undefined;
}

export default function WizardEntityLink({
  entityType,
  entityId,
  label = undefined,
  data = undefined,
}: WizardEntityLinkProps) {
  const { openDetailDrawer } = useWizard();

  return (
    <Tooltip title={`View ${entityType} details`}>
      <span
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          openDetailDrawer(entityType, entityId, data);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.stopPropagation();
            openDetailDrawer(entityType, entityId, data);
          }
        }}
        style={{
          cursor: "pointer",
          color: "#1890ff",
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        {label && <span style={{ textDecoration: "underline" }}>{label}</span>}
        <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: 12 }} />
      </span>
    </Tooltip>
  );
}
